import { render, staticRenderFns } from "./FormAddFinishedReceipt.vue?vue&type=template&id=45d5c238&scoped=true"
import script from "./FormAddFinishedReceipt.vue?vue&type=script&lang=js"
export * from "./FormAddFinishedReceipt.vue?vue&type=script&lang=js"
import style0 from "./FormAddFinishedReceipt.vue?vue&type=style&index=0&id=45d5c238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d5c238",
  null
  
)

export default component.exports